import { triggerSideOrderError } from '../../../../features/chooseSideOrders/chooseSideOrdersSlice';

const reduceList = (list, possibleSideOrderId, amount) =>
  Object.keys(list).reduce((acc, curr) => {
    acc[curr] = {
      ...list[curr],
      [possibleSideOrderId]: {
        ...list[curr][possibleSideOrderId],
        amount,
      },
    };
    return acc;
  }, {});

export const decreaseAllSideOrders =
  (
    allSideOrdersAmount,
    setSideOrdersState,
    sideOrdersState,
    possibleSideOrderId,
    setAllSideOrdersAmount,
    minQuantity
  ) =>
  dispatch => {
    if (allSideOrdersAmount <= minQuantity) {
      setSideOrdersState(reduceList(sideOrdersState, possibleSideOrderId, 0));
      setAllSideOrdersAmount(0);
    } else {
      const amount = allSideOrdersAmount - 1;

      setSideOrdersState(
        reduceList(sideOrdersState, possibleSideOrderId, amount)
      );
      setAllSideOrdersAmount(amount);
    }
    dispatch(triggerSideOrderError(''));
  };

export const increaseAllSideOrders =
  (
    allSideOrdersAmount,
    setSideOrdersState,
    sideOrdersState,
    possibleSideOrderId,
    setAllSideOrdersAmount,
    maxQuantity,
    minQuantity,
    limitedByMaximumSelectedMeals,
    selectedMealsLength,
    mealsLimit,
    chooseSideOrdersList
  ) =>
  dispatch => {
    if (limitedByMaximumSelectedMeals) {
      const globalList = Object.keys(chooseSideOrdersList).reduce(
        (acc, curr) => {
          acc.push(
            Object.values(chooseSideOrdersList[curr])
              .filter(
                item =>
                  item.possibleSideOrderId !== possibleSideOrderId &&
                  item.limitedByMaximumSelectedMeals
              )
              .reduce((acc1, curr1) => acc1 + curr1.amount, 0)
          );
          return acc;
        },
        []
      );

      const highestGlobalValue = globalList.length
        ? Math.max(...globalList)
        : 0;

      const highestLocalValue = Math.max(
        ...Object.keys(sideOrdersState).reduce((acc, curr) => {
          acc.push(
            Object.values(sideOrdersState[curr])
              .filter(
                item =>
                  item.possibleSideOrderId === possibleSideOrderId &&
                  item.limitedByMaximumSelectedMeals
              )
              .reduce((acc1, curr1) => acc1 + curr1.amount, 0)
          );
          return acc;
        }, [])
      );

      const wholeHighestValue =
        highestGlobalValue + allSideOrdersAmount + selectedMealsLength;

      if (minQuantity) {
        if (highestLocalValue === 0) {
          if (wholeHighestValue > mealsLimit) {
            dispatch(triggerSideOrderError('maxMeals'));
            return;
          }

          if (minQuantity + wholeHighestValue > mealsLimit) {
            dispatch(triggerSideOrderError('maxMeals'));
            return;
          }
        }
      }

      if (wholeHighestValue >= mealsLimit) {
        dispatch(triggerSideOrderError('maxMeals'));
        return;
      }
    }

    if (maxQuantity && allSideOrdersAmount >= maxQuantity) {
      dispatch(triggerSideOrderError('maxSideOrders'));
      return;
    }

    const setState = value => {
      setSideOrdersState(
        reduceList(sideOrdersState, possibleSideOrderId, value)
      );
      setAllSideOrdersAmount(value);
    };

    if (minQuantity && allSideOrdersAmount === 0) {
      setState(minQuantity);
    } else {
      const amount = allSideOrdersAmount + 1;
      setState(amount);
    }
    dispatch(triggerSideOrderError(''));
  };

export const decreaseSideOrdersItem =
  (
    amount,
    isoDay,
    setSideOrdersState,
    sideOrdersState,
    possibleSideOrderId,
    minQuantity
  ) =>
  dispatch => {
    const setState = value => {
      setSideOrdersState({
        ...sideOrdersState,
        [isoDay]: {
          ...sideOrdersState[isoDay],
          [possibleSideOrderId]: {
            ...sideOrdersState[isoDay][possibleSideOrderId],
            amount: value,
          },
        },
      });
    };

    if (amount <= minQuantity) {
      setState(0);
    } else {
      setState(amount - 1);
    }
    dispatch(triggerSideOrderError(''));
  };

export const increaseSideOrdersItem =
  (
    amount,
    isoDay,
    setSideOrdersState,
    sideOrdersState,
    possibleSideOrderId,
    maxQuantity,
    minQuantity,
    limitedByMaximumSelectedMeals,
    selectedMealsLength,
    mealsLimit,
    setAllSideOrdersAmount,
    chooseSideOrdersList
  ) =>
  dispatch => {
    if (limitedByMaximumSelectedMeals) {
      const amountFromGlobalState = Object.values(
        chooseSideOrdersList?.[isoDay] || {}
      )
        .filter(
          item =>
            item.possibleSideOrderId !== possibleSideOrderId &&
            item.limitedByMaximumSelectedMeals
        )
        .reduce((acc, curr) => acc + curr.amount, 0);

      const amountFromLocalState = Object.values(
        sideOrdersState?.[isoDay] || {}
      )
        .filter(
          item =>
            item.possibleSideOrderId === possibleSideOrderId &&
            item.limitedByMaximumSelectedMeals
        )
        .reduce((acc, curr) => acc + curr.amount, 0);

      const wholeAmount = amountFromGlobalState + amount + selectedMealsLength;

      if (minQuantity) {
        if (amountFromLocalState === 0) {
          if (wholeAmount > mealsLimit) {
            dispatch(triggerSideOrderError(`maxSingleMeals-${isoDay}`));
            return;
          }

          if (minQuantity + wholeAmount > mealsLimit) {
            dispatch(triggerSideOrderError(`maxSingleMeals-${isoDay}`));
            return;
          }
        }
      }

      if (wholeAmount >= mealsLimit) {
        dispatch(triggerSideOrderError(`maxSingleMeals-${isoDay}`));
        return;
      }
    }

    if (maxQuantity && amount >= maxQuantity) {
      dispatch(triggerSideOrderError(`maxSingleSideOrder-${isoDay}`));
      return;
    }

    const setState = value => {
      setSideOrdersState({
        ...sideOrdersState,
        [isoDay]: {
          ...sideOrdersState[isoDay],
          [possibleSideOrderId]: {
            ...sideOrdersState[isoDay][possibleSideOrderId],
            amount: value,
          },
        },
      });
      setAllSideOrdersAmount(0);
    };

    if (minQuantity && amount === 0) {
      setState(minQuantity);
    } else {
      setState(amount + 1);
    }
    dispatch(triggerSideOrderError(''));
  };

export const calculateSummary = (sideOrdersState, possibleSideOrderId) =>
  Object.values(sideOrdersState).reduce(
    (acc, curr) => {
      const filter = Object.values(curr).filter(
        item => item.possibleSideOrderId === possibleSideOrderId && item.amount
      );

      if (filter.length) {
        acc.priceOfSideOrders += filter.reduce(
          (sum, li) => sum + li.defaultPrice * li.amount,
          0
        );
        acc.numberOfSideOrders += filter.reduce(
          (sum, li) => sum + li.amount,
          0
        );
        acc.days++;
      }

      return acc;
    },
    {
      days: 0,
      numberOfSideOrders: 0,
      priceOfSideOrders: 0,
    }
  );

export const declination = (number, one, moreThanOne, moreThanFour) => {
  if (number === 1) {
    return `${number} ${one}`;
  }

  if (number > 1 && number < 5) {
    return `${number} ${moreThanOne}`;
  }

  return `${number} ${moreThanFour}`;
};

export const parsePrice = (price, toFixed = 2) => {
  if (isNaN(price)) {
    return 0;
  }
  if (!price) {
    return 0;
  }
  if (typeof price === 'number' && price >= 0) {
    return price?.toFixed(toFixed).replace('.', ',');
  }
  return 0;
};
